module.exports = __webpack_public_path__ + "static/BridgetLane-778161c931894e06648b9a5c2bd4262c.jpg";